import axios from 'axios';
import apiConfig from '../../api.config';

export default function validateUserRequest(userId, token, lang) {
  const {
    host,
    URIs: { auth },
  } = apiConfig;

  const uri = `${host}${auth.validateUser}`;

  return axios
    .put(uri, JSON.stringify({ user_id: userId, token, lang: lang }), {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then(res => {
      return res.data;
    });
}
